'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagGhAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 -1.52588e-05C9.33333 9.3154e-05 18.6667 -4.85778e-06 28 -4.85778e-06C28 6.66666 28 13.3333 28 20C18.6667 20 9.33333 20 0 20V-1.52588e-05Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 6.66666H28V-4.85778e-06L0 -1.52588e-05V6.66666Z",
          fill: "#E71F37"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H28V13.3333H0V20Z",
          fill: "#118B56"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 13.3333H28V6.66666H0V13.3333Z",
          fill: "#FDD64C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14 11.6117L12.0407 13.0301L12.7842 10.7284L10.8298 9.30327L13.2486 9.29911L14 7L14.7514 9.29911L17.1702 9.30327L15.2158 10.7284L15.9593 13.0301L14 11.6117Z",
          fill: "#262626"
        }
      )
    ]
  }
);
const VpFlagGhAsset = forwardRef(FlagGhAsset);

export { VpFlagGhAsset as default };
